import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, ArrowRight } from 'lucide-react';

interface DashboardAlertBannerProps {
  whatsappDisconnected: boolean;
  openaiMissing: boolean;
}

const DashboardAlertBanner: React.FC<DashboardAlertBannerProps> = ({
  whatsappDisconnected,
  openaiMissing
}) => {
  if (!whatsappDisconnected && !openaiMissing) {
    return null;
  }

  return (
    <div className="space-y-3 mb-6">
      {whatsappDisconnected && (
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 bg-red-900/10 border border-red-500/20 rounded-lg p-4">
          <AlertTriangle className="text-red-400 flex-shrink-0" size={20} />
          <div className="flex-1">
            <p className="text-red-400 font-medium text-sm sm:text-base">
              WhatsApp Desconectado
            </p>
            <p className="text-red-300/70 text-xs sm:text-sm mt-1">
              Configure sua conexão para enviar e receber mensagens
            </p>
          </div>
          <Link
            to="/settings?tab=conexao"
            className="flex items-center gap-2 px-4 py-2 bg-red-500/20 hover:bg-red-500/30 text-red-400 hover:text-red-300 rounded-md transition-colors text-sm font-medium whitespace-nowrap"
          >
            Conectar Agora
            <ArrowRight size={16} />
          </Link>
        </div>
      )}

      {openaiMissing && (
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 bg-yellow-900/10 border border-yellow-500/20 rounded-lg p-4">
          <AlertTriangle className="text-yellow-400 flex-shrink-0" size={20} />
          <div className="flex-1">
            <p className="text-yellow-400 font-medium text-sm sm:text-base">
              Token OpenAI não configurado
            </p>
            <p className="text-yellow-300/70 text-xs sm:text-sm mt-1">
              Configure sua API Key para usar assistentes de IA
            </p>
          </div>
          <Link
            to="/settings?tab=integracoes"
            className="flex items-center gap-2 px-4 py-2 bg-yellow-500/20 hover:bg-yellow-500/30 text-yellow-400 hover:text-yellow-300 rounded-md transition-colors text-sm font-medium whitespace-nowrap"
          >
            Configurar Token
            <ArrowRight size={16} />
          </Link>
        </div>
      )}
    </div>
  );
};

export default DashboardAlertBanner;
